import { Dialog, Transition } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import React, { Fragment, useState } from 'react';

type Props = {
  callback: () => void;
  error: string;
};

const OrderErrorPopUp: React.FC<Props> = ({ callback, error }) => {
  const [open, setOpen] = useState(true);

  return (
    <Transition.Root show={open} as={Fragment} appear>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => {
          setOpen(false);
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => {
            setOpen(false);
            callback();
          }}
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-error-container px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8  sm:p-6">
                <div className="bg-error-container px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                      <ExclamationTriangleIcon className="text-error" />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <h3
                        className="text-lg leading-6 font-medium text-on-error-container"
                        id="modal-headline"
                      >
                        Unable to submit the order
                      </h3>
                      <div className="mt-2">
                        <p className="text-sm leading-5 text-on-error-container/80">
                          {error}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-error-container px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button
                      type="button"
                      className="inline-flex justify-center w-full rounded-md border border-primary/10 px-4 py-2 bg-primary text-base leading-6 font-medium text-on-primary shadow-sm hover:text-on-primary focus:outline-none focus:border-primary focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                      onClick={callback}
                    >
                      Dismiss
                    </button>
                  </span>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default OrderErrorPopUp;
